import axios from "axios";
import { API_ORIGIN } from "../config/constants";

const authToken = localStorage.getItem("Authtoken");

export class BannerService {
  static bannerCreate = async (bodydata) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/banner-management/create",
        data: bodydata,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };
  static bannerDetails = async (rowsPerPage, page) => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/banner-management/search",
        data: {
          keyword: "",
          status: "",
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "DESC",
        },
      });

      let bannerDetail = response.data.data;

      return bannerDetail;
    } catch (err) {
      throw err;
    }
  };

  static bannerDetailsID = async (bannerID) => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/banner-management/" + bannerID,
        data: {
          filter: [],
          limit: 10,
          skip: 0,
          sort: "DESC",
        },
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let termDetailID = response.data.data;

      return termDetailID;
    } catch (err) {
      throw err;
    }
  };

  static bannerDelete = async (bannerID) => {
    try {
      let response = await axios({
        method: "delete",
        baseURL: API_ORIGIN + "/banner-management/delete/" + bannerID,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static bannerUpdate = async (bannerID, bodyFormData) => {
    try {
      let response = await axios({
        method: "put",
        baseURL: API_ORIGIN + "/banner-management/update/" + bannerID,
        data: bodyFormData,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };
}
